export default "__VITE_ASSET__DbSzcO$v__"